import * as React from 'react';

import {Button} from '../button/button';
import {colors} from '../colors/colors';
import {GridList} from '../grid-list/grid-list';

import styles from './grid-selector.module.css';

type IconItem = {
    id: string;
    type: 'icon';
    content: React.ComponentType<any>;
};

export type ColorItem = {
    id: string;
    type: 'color';
    content: string; // directly control color css style (e.g. 'var(--blue)', '#3b9eD7')
};

export type Item = IconItem | ColorItem;

type Props = {
    items: Array<Item>;
    selectedItemId: string | null | undefined;
    onSelectItem: (itemId: string) => void;
    numColumns?: number;
};

export function GridSelector(props: Props) {
    const numColumns = props.numColumns ?? Math.ceil(props.items.length / 2);

    return (
        <GridList gridGap={8} numColumns={numColumns}>
            {props.items.map((item) =>
                item.type === 'icon' ? (
                    <div key={item.id} className={styles['button-container']}>
                        <Button
                            onClick={() => {
                                props.onSelectItem(item.id);
                            }}
                            className={
                                props.selectedItemId === item.id
                                    ? styles['icon-box--selected']
                                    : styles['icon-box']
                            }
                        >
                            <item.content
                                color={colors.greyLt}
                                fill={colors.greyLt}
                                size={13}
                                style={{color: colors.greyLt}}
                            />
                        </Button>
                    </div>
                ) : (
                    <button
                        type='button'
                        key={item.id}
                        style={{color: item.content}}
                        onClick={() => {
                            props.onSelectItem(item.id);
                        }}
                        className={
                            props.selectedItemId === item.id
                                ? styles['color-swatch-button--selected']
                                : styles['color-swatch-button']
                        }
                    />
                )
            )}
        </GridList>
    );
}
